import axios from 'axios';
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from '../../context/AuthContext';
import { errorNotification, successNotification } from '../../utils/notifications';
import logowhite from "../../assets/endebet-white.svg";
import logo from "../../assets/endebet-blue.svg";
import Background from "../../assets/endebet-image.jpeg";
import api from '../../config/api';


const Login = () => {
    const [credentials, setCredentials] = useState({
        username: undefined,
        password: undefined
    });
    const { loading, error, dispatch } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setCredentials((prev) => ({ ...prev, [e.target.id]: e.target.value }));
    };

    const handleClick = async (e) => {
        console.log(credentials);
        e.preventDefault();
        dispatch({ type: "LOGIN_START" });
        try {
            const res = await api.post("/auth/login", credentials);
            dispatch({ type: "LOGIN_SUCCESS", payload: res.data.details });
            successNotification("Successfull Logged In")
            navigate("/");
        } catch (error) {
            errorNotification(error.response.data["message"])
            dispatch({ type: "LOGIN_FAILURE", payload: error.response.data })
        }
    };




    return (


        <div style={{
            backgroundImage: `linear-gradient(
                          rgba(4, 93, 184, 0.5), 
                          rgba(4, 93, 184, 0.8)
                      ), url(${Background})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
        }}>
            <div className="justify-center min-h-screen mx-0 sm:flex sm:flex-row">
                <div className="z-10 flex flex-col self-center p-10 sm:max-w-5xl xl:max-w-2xl">
                    <div className="flex-col self-start hidden text-white lg:flex">
                        <div className='pb-5'>
                            <img src={logowhite} className='align-center ' />
                        </div>
                        <h1 className="mb-3 text-5xl font-bold">Welcome Back Endebet </h1>
                        <p className="pr-3">Convience in your Palm</p>
                    </div>
                </div>
                <div className="z-10 flex self-center justify-center">
                    <div className="p-12 mx-auto bg-white rounded-2xl w-100">

                        <div className="mb-4">
                            <img src={logo} className=' align-center lg:hidden' />
                            <h3 className="flex self-center justify-center text-2xl font-semibold text-gray-800 align-center">Sign In </h3>
                            <p className="flex self-center justify-center text-gray-500 align-center">Please sign in to your account.</p>
                        </div>
                        <div className="space-y-5">
                            <div className="space-y-2">
                                <label className="text-sm font-medium tracking-wide text-gray-700">Username</label>
                                <input className="w-full px-4 py-2 text-base border border-gray-300 rounded-lg focus:outline-none focus:border-blue-400" type="" id="username" placeholder="Username" onChange={handleChange} />
                            </div>
                            <div className="space-y-2">
                                <label className="mb-5 text-sm font-medium tracking-wide text-gray-700">
                                    Password
                                </label>
                                <input className="w-full px-4 py-2 text-base border border-gray-300 rounded-lg focus:outline-none focus:border-blue-400" type="password" placeholder="Password" id='password' onChange={handleChange} />
                            </div>
                            <div className="flex items-center justify-between">
                                <div className="flex items-center">
                                    <input id="remember_me" name="remember_me" type="checkbox" className="w-4 h-4 bg-blue-500 border-gray-300 rounded focus:ring-blue-400" />
                                    <label for="remember_me" className="block ml-2 text-sm text-gray-800">
                                        Remember me
                                    </label>
                                </div>
                                <div className="text-sm">
                                    <a href="#" className="text-blue-400 hover:text-blue-500">
                                        Forgot your password?
                                    </a>
                                </div>
                            </div>
                            <div>
                                <button type="submit" className="flex justify-center w-full p-3 font-semibold tracking-wide text-gray-100 transition duration-500 ease-in bg-blue-400 rounded-full shadow-lg cursor-pointer hover:bg-blue-500" onClick={handleClick}>
                                    Sign in
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >

    );
};

export default Login